import api from "./index"

export async function getPatients({
  offset = 0,
  limit = 10,
  search = "",
} = {}) {
  const config = {
    params: { offset, limit, search },
  }
  return api.get("/v1/patients", config)
}

export async function getPatientById(patientId) {
  return api.get(`/v1/patients/${patientId}`)
}

export async function createPatient(data) {
  return api.post("/v1/patients", data)
}

export async function updatePatient(patientId, data) {
  return api.put(`/v1/patients/${patientId}`, data)
}

export async function deletePatient(patientId) {
  return api.delete(`/v1/patients/${patientId}`)
}
